module.exports = __webpack_public_path__ + "static/media/broken-image.f3fa5dce.png";